// @ts-nocheck
import React from 'react';
import { ArrowDownRight as _lr_ArrowDownRight, ArrowUpRight as _lr_ArrowUpRight, Minus as _lr_Minus } from 'lucide-react';
import { cn } from '../../lib/utils';

const ArrowDownRight = _lr_ArrowDownRight || (() => null);
const ArrowUpRight = _lr_ArrowUpRight || (() => null);
const Minus = _lr_Minus || (() => null);
const trendMap = {
  up: {
    icon: ArrowUpRight,
    className: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  },
  down: {
    icon: ArrowDownRight,
    className: 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300',
  },
  neutral: {
    icon: Minus,
    className: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
  },
};

/** @param {{ label?: any, value?: any, change?: any, trend?: string, icon?: any, meta?: any, className?: string }} props */
export default function StatCard({
  label,
  value,
  change,
  trend = 'neutral',
  icon,
  meta,
  className = '',
}) {
  const trendConfig = trendMap[trend] || trendMap.neutral;
  const TrendIcon = trendConfig.icon;
  const Icon = icon;

  return (
    <div className={cn(
      'relative overflow-hidden rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-5 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg',
      className
    )}>
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[hsl(var(--primary)_/_0.45)] to-transparent" />
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-3">
          <p className="text-sm font-medium text-[hsl(var(--muted-foreground))]">{label}</p>
          <div className="space-y-1">
            <p className="text-3xl font-semibold tracking-tight text-[hsl(var(--foreground))]">{value}</p>
            {meta ? <p className="text-sm text-[hsl(var(--muted-foreground))]">{meta}</p> : null}
          </div>
        </div>
        {Icon ? (
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[hsl(var(--secondary))] text-[hsl(var(--primary))]">
            <Icon size={20} />
          </div>
        ) : null}
      </div>
      {change ? (
        <div className="mt-5 flex items-center gap-2 text-sm">
          <span className={cn('inline-flex items-center gap-1 rounded-full px-2.5 py-1 font-medium', trendConfig.className)}>
            <TrendIcon size={14} />
            {change}
          </span>
          <span className="text-[hsl(var(--muted-foreground))]">vs last period</span>
        </div>
      ) : null}
    </div>
  );
}
